var angular = require('angular')
require('./services/app.dataservice.js')

angular.module('AemTransparentAccount')
  .controller('AemTransparentAccountCtrl', ctrl)

ctrl.$inject = ['appLoader', 'appDataservice']
function ctrl (appLoader, appDataservice) {
  var vm = this

  vm.$onInit = function () {
    vm.state = appDataservice.state
    appLoader.hide()

    document.title = 'Transparentní účty | Česká spořitelna'
  }
}
